import { ComponentProps, HTMLAttributes } from 'react';
import { Dialog, DialogContent } from '@zep/ui';
import { cn } from '@zep/utils';
import { ChevronLeftIcon } from '../../icons/ChevronLeft';
const LoginDialogRoot = (props: ComponentProps<typeof Dialog>) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <Dialog className={cn('!min-h-[280px] !px-[20px] !pt-[40px]', className)} maxWidth="400px" {...rest} data-sentry-element="Dialog" data-sentry-component="LoginDialogRoot" data-sentry-source-file="common.tsx">
      {children}
    </Dialog>;
};

// ************************************************************

const LoginDialogContent = ({
  children,
  className
}: ComponentProps<typeof DialogContent>) => {
  return <DialogContent className={cn('!px-[20px] !pb-[40px] md:!pb-[48px] !pt-[65px]', 'md:!px-[40px]', className)} data-sentry-element="DialogContent" data-sentry-component="LoginDialogContent" data-sentry-source-file="common.tsx">
      {children}
    </DialogContent>;
};

// ************************************************************

const BackButton = ({
  onClick,
  className,
  ...rest
}: HTMLAttributes<HTMLButtonElement>) => {
  return <button className={cn('cursor-pointer', className)} onClick={onClick} {...rest} data-sentry-component="BackButton" data-sentry-source-file="common.tsx">
      <ChevronLeftIcon data-sentry-element="ChevronLeftIcon" data-sentry-source-file="common.tsx" />
    </button>;
};

// ************************************************************

export { LoginDialogRoot, LoginDialogContent, BackButton };